import { type ReactNode } from 'react';
import { Box, type BoxProps, Divider, type TypographyProps } from '@mui/material';
import { Title } from './styles';

export type TitleWithSeparatorProps = {
  children: ReactNode;
  titleProps?: TypographyProps;
} & BoxProps;

export const TitleWithSeparator = ({ children, titleProps, ...rest }: TitleWithSeparatorProps) => {
  return (
    <Box width="100%" {...rest}>
      <Title variant="h2" {...titleProps}>
        {children}
      </Title>
      <Divider sx={{ marginBottom: 0 }} />
    </Box>
  );
};
